// Port of api/fuel/app/classes/filter/package/games/play/data/games/winpercent.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
export default {
	require: function(config, filter) { return config.ownerType === F.OWNER_USER && filter.play && filter.play.group },
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length) return
		var sql = 'SELECT game_id AS g, SUM(play_count) AS p, SUM(play_result * play_count) AS r, SUM(play_result * play_won) AS w FROM play WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id = ' + config.userID
		if (global.playContextIndex) sql += ' AND play_id IN(' + Util.in(global.playContextIndex) + ')'
		sql += ' GROUP BY game_id'
		global.record = Util.query(sql, false, 'g')
		return global
	}
}
